import React from "react";
import PropTypes from "prop-types";

export default class ResultSummary extends React.Component {
  constructor(props) {
    super(props);
  }

  renderSummary = () => {
    const { dictionary, page, perPage, totalResults } = this.props;

    const firstResult = (page - 1) * perPage + 1;
    const lastResult = (page * perPage) < totalResults ? (page * perPage) : totalResults;
    const resultLanguage = totalResults == 1 ? dictionary.singleresult : dictionary.pluralresult;
    const noResultsText = dictionary.noResultText || "No results found";

    const keyword = new URLSearchParams(document.location.search).get("q");

    const generateText = () => {
      let text = "";

      if(totalResults > perPage) {
        text = `${ firstResult } to ${ lastResult } of `;
      }

      return text + `${totalResults} ${ resultLanguage } found`;
    }

    if (totalResults > 0) {
      return (
        <div className="search__info-results" aria-live="polite" aria-atomic="true">{ generateText() }{keyword && <span className="visually-hidden"> for {keyword}</span>}
        </div>);
    }

    return (<div className="search__info-results" aria-live="polite">{noResultsText}</div>);
  }

  render() {

    return this.renderSummary();
  }
}

const { number, object } = PropTypes;

ResultSummary.propTypes= {
  dictionary: object,
  page: number,
  perPage: number,
  totalResults: number
};
